import { render, staticRenderFns } from "./Gdhk1.vue?vue&type=template&id=6d847a8c&scoped=true"
import script from "./Gdhk1.vue?vue&type=script&lang=js"
export * from "./Gdhk1.vue?vue&type=script&lang=js"
import style0 from "./Gdhk1.vue?vue&type=style&index=0&id=6d847a8c&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d847a8c",
  null
  
)

export default component.exports